import _ from 'lodash'

export default {
  getToken(state: any) {
    return _.get(state, 'token', null);
  },
  isLogged(state: any) {
    return _.get(state, 'logged', null); 
  },
};
